export default "__VITE_ASSET__c181fb3b__"